import ScreenIcon from '@atlaskit/icon/core/screen';
import * as React from 'react';

export function SvgDesktopMac() {
  return <ScreenIcon label="" testId="ads-refreshed-icon" />;
}
